export const OPEN = "modal.OPEN";
export const CLOSE = "modal.CLOSE";
